// js/accounts/nostr/config.js
// Constants used by the Nostr login + sync subsystem.

export const APP_NAME_KEY = 'monochrome';

// Default relays used for general read/write operations.
// NIP-65 mailbox events from the active user override these at runtime.
export const HARDCODED_RELAYS = [
    'wss://relay.damus.io',
    'wss://nos.lol',
    'wss://relay.primal.net',
    'wss://nostr.wine',
];

// Default relays for NIP-46 (Nostr Connect) signing flows.
// Users can edit this list before initiating a QR connect flow.
export const HARDCODED_SIGNER_RELAYS = ['wss://relay.nsec.app', 'wss://relay.damus.io'];

// NIP-78 (kind 30078) replaceable event d-tag identifiers used for
// per-category app data. Each tag maps to one IndexedDB store / sync slice.
export const D_TAGS = {
    libraryTracks: 'monochrome:library:tracks',
    libraryAlbums: 'monochrome:library:albums',
    libraryArtists: 'monochrome:library:artists',
    libraryPlaylists: 'monochrome:library:playlists',
    libraryMixes: 'monochrome:library:mixes',
    folders: 'monochrome:folders',
    history: 'monochrome:history',
    profile: 'monochrome:profile',
    settings: 'monochrome:settings',
};

// Helper: build the d-tag for a single user-created playlist.
export const playlistDTag = (uuid) => `monochrome:playlist:${uuid}`;

// localStorage key used by the session facade to remember which auth
// backend was active last (Appwrite vs Nostr).
export const LAST_ACTIVE_SESSION_KEY = 'monochrome-last-active-session';
